module.exports = __webpack_public_path__ + "assets/img/jindutiao2_cn.139ad203.png";